import React from 'react';

import { Button } from 'components';
import './blog-card.less';

import BlogCardImage from 'assests/images/blog-card-image.png';
import BlogCardImageMobile from 'assests/images/blog-card-image-mobile.png';

const BlogCard = ({ image, imageMobile, title, paragraph, date }) => {
  return (
    <div className="blog-card">
      <figure className='blog-card__image'>
        <img className="desktop" src={ image } alt='Blog Card Image' />
        <img className="mobile" src={ imageMobile } alt='Blog Card Image' />
      </figure>
      <div className='blog-card__body'>
        <strong>{ title }</strong>
        <p>{ paragraph }</p>
        <div>
          <span>{ date }</span>
          <Button type="primary" shape="round" href="/">
            Read More
          </Button>
        </div>
      </div>
    </div>
  )
}
export default BlogCard;

BlogCard.defaultProps = {
  image: BlogCardImage,
  imageMobile: BlogCardImageMobile,
  title: 'Company Imperfect, by design',
  paragraph: 'The journey to responsible, responsive, and community-driven machine learning (ML) systems is a collaborative.',
  date: '18 May 2021'
};